<template>
  <!-- 设备控制相关 -->
  <div v-if="loading">
    <van-skeleton title :row="10"></van-skeleton>
  </div>
  <div v-else-if="isEmpty">
    <empty-notice :desc="'暂无内容'"></empty-notice>
  </div>
  <div v-else class="device-ctrl-container">
    <van-cell v-show="roomNum" :title="roomNum" class="mar-btm text-bold"></van-cell>

    <div v-if="deviceConfig.meetingMode.length" class="bg-white mar-btm">
      <div class="pad-ver-10 pad-hor">会议模式</div>
      <van-grid :column-num="deviceConfig.meetingMode.length">
        <van-grid-item v-for="(ele, idx) in deviceConfig.meetingMode" :key="idx" @click="handleControl(ele)"
                       :class="ele.style || 'text-primary'">
          <span class="van-grid-item__text text-lg text-bold">{{ele.label}}</span>
        </van-grid-item>
      </van-grid>
    </div>

    <div v-if="deviceConfig.environment.length" class="bg-white mar-btm">
      <div class="pad-top-10 pad-hor">环境控制</div>
      <van-divider class="mar-ver-10"></van-divider>

      <div class="device-ctrl-card" v-for="(ele, index) in deviceConfig.environment" :key="index">
        <div class="device-ctrl-item">
          <img :src="getEnvImg(ele)"/>
          <span class="device-name text-hv">{{ele.label}}</span>
          <div v-if="ele.options" class="device-btn-container">
            <van-button v-for="(opt, idx) in ele.options" round type="primary" :key="'opt'+idx"
                        :class="opt.style" @click="handleControl(ele, opt.params)">{{opt.label}}
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="deviceConfig.system.length" class="mar-top-20">
      <van-button v-for="(ele, index) in deviceConfig.system" :key="index" block
                  class="mar-btm text-bold" :class="ele.style" @click="handleControl(ele)">{{ele.label}}
      </van-button>
    </div>
  </div>
</template>

<script>
  import {meetingRoom, system} from "../../../../server"
  import {checkRespCorrect, frontConfirm} from "../../../../tools/utils";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";

  const styleMap = {
    primary: "van-button--primary",
    danger: "van-button--danger",
    plain: "van-button--plain"
  };
  export default {
    name: 'DeviceControl',
    data() {
      return {
        loading: true,
        rid: "",
        roomNum: "",
        devices: [],
        deviceSettings: {},
        lightActive: true,
        showSingleCtrl: false
      };
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      deviceConfig() {
        const cfg = {
          system: [],
          meetingMode: [],
          environment: [],
        };
        if (this.devices.length) {
          Object.keys(cfg).forEach(key => {
            cfg[key] = this.assembleCmdInfo(this.deviceSettings[key] || [])
          })
        }
        return cfg
      },
      isEmpty() {
        return Object.keys(this.deviceConfig).every(k => !this.deviceConfig[k].length)
      }
    },
    created() {
      this.rid = this.$route.params.rid;
      this.getRoomDeviceInfo()
    },
    methods: {
      getRoomDeviceInfo() {
        // 查询设备信息
        system.queryDeviceInfo(this, {rid: this.rid}).then(({queryDeviceInfo: resp = {}}) => {
          if (checkRespCorrect(resp)) {
            const {devices, ctrSettings, roomNum} = resp.data || {};
            this.roomNum = roomNum || "";
            this.devices = devices || [];
            try {
              this.deviceSettings = JSON.parse(ctrSettings);
            } catch (e) {
              console.log(e.message)
            }
          }
          this.loading = false
        }).catch(err => {
          this.loading = false;
          vtToast(err.message)
        })
      },
      // 组装设备源数据
      assembleCmdInfo(arr) {
        const data = [];
        arr.forEach(doc => {
          const info = {style: styleMap[doc.style] || doc.style};
          if (doc.deviceType) {
            const device = this.devices.find(e => e.deviceType === doc.deviceType);
            if (!device) return;
            info.deviceId = device.relationId
          }
          if (doc.options) {
            info.options = doc.options.map(e => ({...e, style: styleMap[e.style] || e.style}))
          }
          data.push({...doc, ...info})
        });
        return data
      },
      // 相应设备icon
      getEnvImg(doc) {
        let img = "";
        switch (doc.type) {
          case 'light':
            img = "light-on";
            break;
          case 'curtain':
            img = "curtain";
            break;
          default:
            img = "empty/normal"
        }
        return require(`../../../../assets/${img}.png`);
      },
      handleControl({cmd, deviceId}, params = {}) {
        frontConfirm({msg: `下发控制可能会影响此${this.roomTitle}的会议，是否确认？`}, () => {
          const data = {
            ...cmd,
            roomId: this.rid,
            deviceId,
            params: JSON.stringify({  // 省略graphql数据结构
              ...cmd.params,
              ...params
            })
          };
          // console.log(data)
          // 发送设备指令
          UILoader.load("执行中...");
          meetingRoom.sendCommand(this, {data: data}).then(({sendCommand: resp = {}}) => {
            if (checkRespCorrect(resp, "控制失败")) {
              messageHdl({code: msgCode.SUCCESS, msg: "发送成功"});
            }
          }).catch(err => {
            messageHdl({msg: err.message})
          })
        })
      },
    }
  };
</script>

<style scoped lang="less">

  .device-ctrl-container {
    padding: 16px;

    .van-button {
      height: 40px;
    }

    .van-cell::after {
      border-bottom: none;
    }

    img {
      width: 60px;
      height: 60px;
    }

    .device-ctrl-card {
      padding: 12px 16px 15px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      border-radius: 4px;

      .device-ctrl-item {
        position: relative;

        .device-name {
          position: absolute;
          top: 20px;
          left: 75px;
          font-size: 18px;
          font-weight: bold;
        }

        .device-btn-container {
          position: absolute;
          top: 20px;
          right: 0;

          .van-button {
            height: 24px;
            padding: 0 10px;
            font-size: 12px;
            font-weight: bold;
            margin-left: 10px;
          }
        }
      }
    }
  }

</style>
